import React from 'react';
import { GoalType } from '../../api/useGoalsQuery';
import { Retirement } from '../../goals/Retirement/Retirement';
import { Education } from '../../goals/Education/Education';
import { LargePurchase } from '../../goals/LargePurchase/LargePurchase';
import { EmergencyFund } from '../../goals/EmergencyFund/EmergencyFund';
import { HealthCare } from '../../goals/HealthCare/HealthCare';
import { Insurance } from '../../goals/Insurance/Insurance';
import { DebtManagement } from '../../goals/DebtManagement/DebtManagement';
import { EstatePlanning } from '../../goals/EstatePlanning/EstatePlanning';
import { HomePurchase } from '../../goals/HomePurchase/HomePurchase';
import { Decumulation } from '../../goals/Decumulation/Decumulation';
import { GoalComponentProps } from './Goal.meta';
import { CharitableGiving } from '../../goals/CharitableGiving/CharitableGiving';

const COMPONENT_DICT = {
  [GoalType.HomePurchase]: HomePurchase,
  [GoalType.Retirement]: Retirement,
  [GoalType.Education]: Education,
  [GoalType.LargePurchase]: LargePurchase,
  [GoalType.EmergencyFund]: EmergencyFund,
  [GoalType.HealthCare]: HealthCare,
  [GoalType.Insurance]: Insurance,
  [GoalType.DebtManagement]: DebtManagement,
  [GoalType.EstatePlanning]: EstatePlanning,
  [GoalType.Decumulation]: Decumulation,
  [GoalType.CharitableGiving]: CharitableGiving,
};

export const Goal = (props: GoalComponentProps) => {
  const { type } = props;
  const Component = COMPONENT_DICT[type];

  return <Component {...props} />;
};
